/*{"ResultStatus":false,"ResultObject":[],"ResultObjectEx":"","ErrorList":["Please enter URL to the textbox below."]}*/

import {ProcessResult} from "../../../domain/process-result/interfaces";

export interface IAudioBase64 {
    ind: number,
    sasUrl: string
}

export interface IAudioBase64Wrapper{
    base64Str:string;
    root: Root;
    pResult: ProcessResult;
}

export interface Error {
    errorCode: number;
    errorDescription: string;
}

export interface Root {
    error: Error;
    sasUrl: string;
    appCode: any;
    env: any;
}

export enum AudioBase64StyleEnum {
    DefaultStyle = 1,
    ChainStyle  = 2,
    IconStyle = 3
}